import { MassFundsDistributionForm } from 'core/centrocosto/components/MassFundsDistributionForm/MassFundsDistributionForm';
import { MassFundsDistributionContext } from 'core/centrocosto/contexts/MassFundsDistributionContext';
import { useContext } from 'react';
import { Alert, Container } from 'react-bootstrap';

export const MassFundsDistributionPage = () => {
  const { availableCostCentres } = useContext(MassFundsDistributionContext);

  return (
    <Container>
      <h1>Transferencia masiva entre cuentas</h1>
      {!!availableCostCentres && availableCostCentres.centrosCosto.length > 0 ? (
        <MassFundsDistributionForm availableCostCentres={availableCostCentres} />
      ) : (
        <Alert className="text-center">
          No posee ningún centro de costos asociado o bien no tiene permisos para realizar
          distribución masiva.
        </Alert>
      )}
    </Container>
  );
};
